import { fetchFormConfigurations } from "../../inputFormConfigurations";
import { setInitialState } from "../../../utils/reducerOperations";
export function Default() {
  return {
    verifyPasswordApi: setInitialState({ sessionExpired: false }),
    isFormValid: false,
    inputBoxConfiguration: fetchFormConfigurations(["newPassword", "confirm"]),
  };
}
